import { c as commonjsGlobal, a as createCommonjsModule } from './_commonjsHelpers-556cd408.js';
import { f as _objectSpread2$1, b as _createClass, c as _classCallCheck, e as _defineProperty$1, k as _asyncToGenerator, l as _regeneratorRuntime, j as _slicedToArray$1 } from './_rollupPluginBabelHelpers-047e4aae.js';
import React, { useEffect, useState } from 'react';
import PropTypes, { object } from 'prop-types';
import 'react-dom';
import { _ as _slicedToArray, a as _objectSpread2 } from './_rollupPluginBabelHelpers-b9ad31fa-7ae21c08.js';
import styled, { withTheme } from 'styled-components';
import { s as styleInject } from './withTooltip-92e0dfed.js';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import { I as Icon, S as SearchIcon } from './index-28a062d6-3659b895.js';
import { C as Context } from './index-155df85b-a520c7f0.js';
import { T as Text } from './text-5e5c8ea1.js';
import '@styled-system/layout';
import '@styled-system/flexbox';
import '@styled-system/position';
import '@styled-system/shadow';
import { B as Box } from './box-e581bc98.js';
import { L as Loader } from './loader-4d85b9a1.js';
import Bole from './bole.js';
import { u as useEnterKey } from './useEnterKey-1841e752-4d3d6e9b.js';
import { F as Fuse } from './fuse-b0dfead8-7a3d565d.js';
import { I as IconWrapper, g as getObjectValue } from './IconWrapper-f69d60c7-8a74d4d9.js';
import '@styled-system/grid';
import '@styled-system/background';
import './index.esm-f8e9e79f-5619e21b.js';
import { A as AddIconV2 } from './AddIconV2-d0c3852f.js';
import { A as Animate, a as APIRequest } from './utils-921758b5.js';

var css_248z = ".Search_searchWrapper__23GwC {\n  position: relative;\n  z-index: 1000000002; }\n\n.Search_search__2io88 {\n  position: relative;\n  border: 1px solid #ddd;\n  border-radius: 100px;\n  overflow: hidden;\n  background-color: #fff;\n  transition: 0.2s ease-out;\n  display: flex;\n  align-items: center; }\n  .Search_search__2io88.Search_active__2pwAt {\n    border-color: #124fa0; }\n    .Search_search__2io88.Search_active__2pwAt.Search_withDropdown__1HNno {\n      border-color: transparent;\n      background-color: transparent; }\n    .Search_search__2io88.Search_active__2pwAt .Search_searchIcon__1fe4d #search {\n      stroke: #124fa0; }\n\n.Search_searchIcon__1fe4d {\n  pointer-events: none;\n  width: 22px;\n  height: 22px;\n  position: absolute;\n  top: 50%;\n  left: 8px;\n  transform: translateY(-50%); }\n  .Search_searchIcon__1fe4d #search {\n    transition: 0.2s ease-out; }\n\n.Search_searchInput__jeW_Q {\n  border: none;\n  outline: none;\n  flex: 1;\n  box-sizing: border-box;\n  resize: none;\n  background-color: transparent;\n  box-shadow: none;\n  padding: 6px 10px;\n  padding-left: 32px;\n  display: inline; }\n  .Search_searchInput__jeW_Q .Search_hint__3zfE4 {\n    text-align: right; }\n\n.Search_hint__3zfE4 {\n  color: #AAA;\n  font-size: 10px;\n  font-weight: 300;\n  padding: 6px;\n  padding-right: 12px;\n  user-select: none;\n  pointer-events: none; }\n";
var styles = {"searchWrapper":"Search_searchWrapper__23GwC","search":"Search_search__2io88","active":"Search_active__2pwAt","withDropdown":"Search_withDropdown__1HNno","searchIcon":"Search_searchIcon__1fe4d","searchInput":"Search_searchInput__jeW_Q","hint":"Search_hint__3zfE4"};
styleInject(css_248z);

var FUSE_OPTIONS = {
  shouldSort: true,
  threshold: 0.2,
  tokenize: true,
  matchAllTokens: true,
  findAllMatches: true,
  location: 0,
  distance: 50,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: ["title"]
};
function Search(_ref) {
  var className = _ref.className,
    prefixClassName = _ref.prefixClassName,
    options = _ref.options,
    onChange = _ref.onChange,
    onType = _ref.onType,
    onSubmit = _ref.onSubmit,
    searchKeys = _ref.searchKeys,
    autoFocus = _ref.autoFocus,
    hint = _ref.hint,
    placeholder = _ref.placeholder,
    value = _ref.value,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    style = _ref.style;
  var _React$useContext = React.useContext(Context),
    primaryColor = _React$useContext.primaryColor;
  var fuse = React.useRef();
  var searchInputRef = React.useRef();
  var _React$useState = React.useState(""),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    searchTerm = _React$useState2[0],
    setSearchTerm = _React$useState2[1];
  var _React$useState3 = React.useState(""),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    focused = _React$useState4[0],
    setFocused = _React$useState4[1];
  var handleSearch = React.useCallback(function (e) {
    var termToSearch = e.target.value;
    if (!termToSearch.length) onChange(options);else onChange(fuse.current.search(termToSearch));
    onType(termToSearch, e);
    setSearchTerm(termToSearch);
  });
  var handleFocus = React.useCallback(function (e) {
    setFocused(true);
    onFocus(e);
  });
  var handleBlur = React.useCallback(function (e) {
    setFocused(false);
    onBlur(e);
  });
  useEffect(function () {
    FUSE_OPTIONS.keys = searchKeys;
    fuse.current = new Fuse(options, FUSE_OPTIONS);
  });
  useEffect(function () {
    setSearchTerm(value);
  }, [value]);
  useEffect(function () {
    if (autoFocus && searchInputRef.current) searchInputRef.current.focus();
  }, [autoFocus]);
  useEnterKey(onSubmit, searchInputRef);
  var activeClassName = focused ? styles.active : "";
  return /*#__PURE__*/React.createElement("div", {
    style: _objectSpread2({
      borderColor: focused ? primaryColor : undefined
    }, style),
    className: "".concat(styles.search, " ").concat(prefixClassName, " ").concat(className, " ").concat(activeClassName)
  }, /*#__PURE__*/React.createElement(Icon, {
    src: SearchIcon,
    className: "".concat(styles.searchIcon, " ").concat(prefixClassName, "-icon")
  }), /*#__PURE__*/React.createElement("input", {
    ref: searchInputRef,
    type: "text",
    placeholder: placeholder,
    className: "".concat(styles.searchInput, " ").concat(prefixClassName, "-input"),
    onChange: handleSearch,
    value: searchTerm,
    autoFocus: autoFocus,
    onFocus: handleFocus,
    onBlur: handleBlur
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.hint, " ").concat(prefixClassName, "-hint")
  }, hint));
}
Search.propTypes = {
  /** The classname to appended to the outermost element */
  className: PropTypes.string,
  /** The prefix classname appended to all elements */
  prefixClassName: PropTypes.string,
  /** The input placeholder */
  placeholder: PropTypes.string,
  /** Whenever you type, an onChange callback is triggered with the results */
  onChange: PropTypes.func,
  /** Object keys to search when finding */
  searchKeys: PropTypes.array,
  /** The array of object to search */
  options: PropTypes.array,
  /** Whether to auto focus or not */
  autoFocus: PropTypes.bool,
  /** The hint text that shows up inside the search input */
  hint: PropTypes.string,
  /** The onChange for the input (callback called with searchTerm as param) */
  onType: PropTypes.func,
  /** The onFocus for the input (callback called when focusing the input) */
  onFocus: PropTypes.func,
  /** The onBlur for the input (callback called with blurring the input) */
  onBlur: PropTypes.func,
  /** When enter key is pressed to initiate the search */
  onSubmit: PropTypes.func,
  /** The search input value */
  value: PropTypes.string,
  /** Style prop */
  style: PropTypes.object
};
Search.defaultProps = {
  placeholder: "",
  onChange: function onChange() {},
  onSubmit: function onSubmit() {},
  searchKeys: [],
  options: [],
  autoFocus: false,
  className: "",
  hint: "",
  onType: function onType() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  style: {}
};
Search.classNames = {
  $prefix: "Outermost element",
  "$prefix-icon": "Search Icon",
  "$prefix-input": "Search input",
  "$prefix-hint": "Search hint"
};
Search.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Search",
  "props": {
    "placeholder": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The input placeholder"
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Whenever you type, an onChange callback is triggered with the results"
    },
    "onSubmit": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "When enter key is pressed to initiate the search"
    },
    "searchKeys": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "Object keys to search when finding"
    },
    "options": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "The array of object to search"
    },
    "autoFocus": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Whether to auto focus or not"
    },
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The classname to appended to the outermost element"
    },
    "hint": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The hint text that shows up inside the search input"
    },
    "onType": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "The onChange for the input (callback called with searchTerm as param)"
    },
    "onFocus": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "The onFocus for the input (callback called when focusing the input)"
    },
    "onBlur": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "The onBlur for the input (callback called with blurring the input)"
    },
    "style": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "Style prop"
    },
    "prefixClassName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The prefix classname appended to all elements"
    },
    "value": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The search input value"
    }
  }
};

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

var _stackClear = stackClear;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol = _root.Symbol;

var _Symbol = Symbol;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$2 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var Map = _getNative(_root, 'Map');

var _Map = Map;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$3.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

var _Hash = Hash;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

var _MapCache = MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

var _Stack = Stack;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach;

var defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty = defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty) {
    _defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$4.call(object, key) && eq_1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$5.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

var isArguments_1 = isArguments;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray_1 = isArray;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

var isLength_1 = isLength;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$6.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$8;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$7.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && _copyObject(source, keys_1(source), object);
}

var _baseAssign = baseAssign;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject_1(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$8.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

var keysIn_1 = keysIn;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && _copyObject(source, keysIn_1(source), object);
}

var _baseAssignIn = baseAssignIn;

var _cloneBuffer = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
});

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

var stubArray_1 = stubArray;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$b.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray_1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};

var _getSymbols = getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}

var _copySymbols = copySymbols;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush;

/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols$1 ? stubArray_1 : function(object) {
  var result = [];
  while (object) {
    _arrayPush(result, _getSymbols(object));
    object = _getPrototype(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}

var _copySymbolsIn = copySymbolsIn;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}

var _getAllKeys = getAllKeys;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return _baseGetAllKeys(object, keysIn_1, _getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn;

/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root, 'DataView');

var _DataView = DataView;

/* Built-in method references that are verified to be native. */
var Promise = _getNative(_root, 'Promise');

var _Promise = Promise;

/* Built-in method references that are verified to be native. */
var Set = _getNative(_root, 'Set');

var _Set = Set;

/* Built-in method references that are verified to be native. */
var WeakMap = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap;

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$1 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$1 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$1) ||
    (_Map && getTag(new _Map) != mapTag$1) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != setTag$1) ||
    (_WeakMap && getTag(new _WeakMap) != weakMapTag$1)) {
  getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$1;
        case mapCtorString: return mapTag$1;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$1;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag;

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$c.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$9.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray;

/** Built-in value references. */
var Uint8Array = _root.Uint8Array;

var _Uint8Array = Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return _cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$2:
      return _cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return _cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor;

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return _cloneRegExp(object);

    case setTag$2:
      return new Ctor;

    case symbolTag:
      return _cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject_1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

var _initCloneObject = initCloneObject;

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike_1(value) && _getTag(value) == mapTag$3;
}

var _baseIsMap = baseIsMap;

/* Node.js helper references. */
var nodeIsMap = _nodeUtil && _nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap;

var isMap_1 = isMap;

/** `Object#toString` result references. */
var setTag$3 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike_1(value) && _getTag(value) == setTag$3;
}

var _baseIsSet = baseIsSet;

/* Node.js helper references. */
var nodeIsSet = _nodeUtil && _nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet;

var isSet_1 = isSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    mapTag$4 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$1 = '[object Symbol]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$2] = cloneableTags[arrayTag$1] =
cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$3] =
cloneableTags[boolTag$2] = cloneableTags[dateTag$2] =
cloneableTags[float32Tag$2] = cloneableTags[float64Tag$2] =
cloneableTags[int8Tag$2] = cloneableTags[int16Tag$2] =
cloneableTags[int32Tag$2] = cloneableTags[mapTag$4] =
cloneableTags[numberTag$2] = cloneableTags[objectTag$2] =
cloneableTags[regexpTag$2] = cloneableTags[setTag$4] =
cloneableTags[stringTag$2] = cloneableTags[symbolTag$1] =
cloneableTags[uint8Tag$2] = cloneableTags[uint8ClampedTag$2] =
cloneableTags[uint16Tag$2] = cloneableTags[uint32Tag$2] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag$2] =
cloneableTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject_1(value)) {
    return value;
  }
  var isArr = isArray_1(value);
  if (isArr) {
    result = _initCloneArray(value);
    if (!isDeep) {
      return _copyArray(value, result);
    }
  } else {
    var tag = _getTag(value),
        isFunc = tag == funcTag$2 || tag == genTag$1;

    if (isBuffer_1(value)) {
      return _cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$2 || tag == argsTag$2 || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : _initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? _copySymbolsIn(value, _baseAssignIn(result, value))
          : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = _initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new _Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet_1(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap_1(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? _getAllKeysIn : _getAllKeys)
    : (isFlat ? keysIn_1 : keys_1);

  var props = isArr ? undefined : keysFunc(value);
  _arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_SYMBOLS_FLAG$1 = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return _baseClone(value, CLONE_DEEP_FLAG$1 | CLONE_SYMBOLS_FLAG$1);
}

var cloneDeep_1 = cloneDeep;

var WarningIconV2 = function WarningIconV2(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9091 14.3684H11.0909V9.63158H12.9091V14.3684ZM12.9091 18.1579H11.0909V16.2632H12.9091V18.1579ZM2 21H22L12 3L2 21Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.yellow.neon)
  })));
};
WarningIconV2.propTypes = {
  iconColor: PropTypes.string
};
WarningIconV2.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "WarningIconV2",
  "props": {
    "iconColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
var WarningIconV2$1 = withTheme(WarningIconV2);

var debounce = function debounce(callback, wait) {
  var timeoutId = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(function () {
      // eslint-disable-next-line prefer-spread
      callback.apply(null, args);
    }, wait);
  };
};

var ButtonWrapper = styled(Box)(function (props) {
  return {
    cursor: props.isDisabled ? "not-allowed" : "pointer",
    alignItems: "center"
  };
});
var ButtonText = styled(Text)({
  marginLeft: 8
});
function AddButton(_ref) {
  var onClick = _ref.onClick,
    isDisabled = _ref.isDisabled;
  return /*#__PURE__*/React.createElement(ButtonWrapper, {
    "data-testid": "globalconstants-add-button",
    padding: "0px",
    onClick: !isDisabled ? onClick : null,
    isDisabled: isDisabled
  }, /*#__PURE__*/React.createElement(AddIconV2, {
    iconColor: isDisabled ? "grey.dark" : "blue.haptik"
  }), /*#__PURE__*/React.createElement(ButtonText, {
    variant: "h3.semi-bold",
    color: isDisabled ? "grey.dark" : "blue.haptik",
    isDisabled: isDisabled
  }, "Add a Bot Variable"));
}
AddButton.propTypes = {
  /** When user clicks on the button */
  onClick: PropTypes.func,
  /** Whether the button is disabled or not */
  isDisabled: PropTypes.bool
};
AddButton.defaultProps = {
  onClick: function onClick() {},
  isDisabled: false
};
AddButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AddButton",
  "props": {
    "onClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "When user clicks on the button"
    },
    "isDisabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Whether the button is disabled or not"
    }
  }
};

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var EmptyStateIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "144",
  height: "144",
  viewBox: "0 0 144 144",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("circle", {
  opacity: ".3",
  cx: "72",
  cy: "72",
  r: "72",
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.03 102H51.315A3.315 3.315 0 0148 98.685v-53.37A3.315 3.315 0 0151.315 42H90.03a3.315 3.315 0 013.315 3.315v53.37A3.315 3.315 0 0190.03 102z",
  fill: "#E0ECFC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.957 98.685v-53.37A3.315 3.315 0 0159.27 42h-7.955A3.315 3.315 0 0048 45.315v53.37A3.315 3.315 0 0051.316 102h7.955a3.315 3.315 0 01-3.314-3.315z",
  fill: "#C4DDFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.959 59.07H71.873a1.06 1.06 0 01-1.061-1.06v-1.837c0-.585.475-1.06 1.06-1.06H87.96c.586 0 1.06.475 1.06 1.06v1.837a1.06 1.06 0 01-1.06 1.06z",
  fill: "#BDD9FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.02 51.258H52.325a1.193 1.193 0 110-2.387h36.693a1.193 1.193 0 110 2.387zM68.303 58.285H52.326a1.193 1.193 0 110-2.387h15.977a1.193 1.193 0 110 2.387z",
  fill: "#2767D7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.959 95.656H53.386a1.06 1.06 0 01-1.06-1.06v-8.66c0-.586.475-1.06 1.06-1.06H87.96c.586 0 1.06.474 1.06 1.06v8.66a1.06 1.06 0 01-1.06 1.06zM87.959 67.026H71.873a1.06 1.06 0 01-1.061-1.06v-1.837c0-.586.475-1.06 1.06-1.06H87.96c.586 0 1.06.474 1.06 1.06v1.836a1.06 1.06 0 01-1.06 1.06z",
  fill: "#BDD9FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.303 66.24H52.326a1.193 1.193 0 110-2.386h15.977a1.193 1.193 0 110 2.387z",
  fill: "#2767D7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.959 74.981H71.873a1.06 1.06 0 01-1.061-1.06v-1.836c0-.586.475-1.061 1.06-1.061H87.96c.586 0 1.06.475 1.06 1.06v1.837a1.06 1.06 0 01-1.06 1.06z",
  fill: "#BDD9FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.303 74.196H52.326a1.193 1.193 0 110-2.386h15.977a1.193 1.193 0 110 2.386zM89.02 80.826H52.325a1.193 1.193 0 110-2.387h36.693a1.193 1.193 0 110 2.387z",
  fill: "#2767D7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.293 68.07l-.641-.184c-.826-.238-1.252-1.282-.952-2.332l2.96-10.359c.3-1.05 1.212-1.707 2.037-1.47l.641.185c.826.238 1.252 1.281.952 2.331l-2.96 10.36c-.3 1.049-1.212 1.707-2.037 1.47z",
  fill: "#FFC34C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.68 81.68l-2.51 8.997.026.145.738 2.725c.088.326.42.424.663.195l2.142-2.014 2.512-8.996-3.57-1.052z",
  fill: "#FFEA63"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.688 91.243l-.026-.145 2.506-8.98-1.487-.438-2.512 8.997.027.145.738 2.725c.088.326.42.424.663.195l.612-.575-.52-1.924z",
  fill: "#FFD551"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.522 92.24l.339 1.226c.096.348.457.452.722.208l.935-.859-1.996-.575z",
  fill: "#A56021"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.672 89.14l-4.135-1.191c-.38-.11-.591-.542-.47-.966l10.709-37.502c.46-1.615 2.011-2.586 3.462-2.168l.259.074c1.45.418 2.253 2.066 1.792 3.68L85.58 88.572c-.12.424-.527.678-.908.568z",
  fill: "#FFA730"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.036 88.638c-.38-.11-.59-.542-.47-.966L93.275 50.17c.33-1.159 1.223-1.983 2.236-2.203a2.497 2.497 0 00-1.014-.58l-.259-.074c-1.45-.418-3.001.553-3.462 2.168l-10.71 37.503c-.12.423.09.855.471.965l4.135 1.19a.648.648 0 00.192.025l-1.828-.526z",
  fill: "#E58D23"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.003 55.636l-5.342-1.473a.73.73 0 01-.51-.897l.13-.47a.73.73 0 01.897-.51l5.342 1.473a.73.73 0 01.51.897l-.13.47a.73.73 0 01-.897.51z",
  fill: "#FFEA63"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.793 53.928l.096-.347c.116-.423.518-.68.898-.576l-2.624-.723c-.38-.104-.782.153-.898.575l-.096.348c-.116.422.097.85.477.954l2.624.723c-.38-.105-.593-.532-.477-.954z",
  fill: "#FFD551"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.922 62.318a.795.795 0 01-.768-1.007l.44-1.599a.795.795 0 111.535.423l-.44 1.599a.796.796 0 01-.767.584zM88.758 73.796a.796.796 0 01-.767-1.007l2.55-9.255a.795.795 0 111.534.424l-2.55 9.253a.796.796 0 01-.767.585z",
  fill: "#FFC34C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.82 98.358a.796.796 0 01-.795-.795V76.469a.796.796 0 011.591 0v21.094c0 .44-.356.795-.795.795z",
  fill: "#FCF9DE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.326 48.871a1.193 1.193 0 100 2.387h3.63V48.87h-3.63zM52.326 78.439a1.193 1.193 0 100 2.387h3.63v-2.387h-3.63zM52.326 71.81a1.193 1.193 0 100 2.386h3.63V71.81h-3.63zM52.326 63.854a1.193 1.193 0 100 2.387h3.63v-2.387h-3.63zM52.326 55.898a1.193 1.193 0 100 2.387h3.63v-2.387h-3.63z",
  fill: "#0D4CB9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.386 84.876a1.06 1.06 0 00-1.06 1.06v8.66c0 .585.475 1.06 1.06 1.06h2.57v-10.78h-2.57zM60.314 47.517a2.01 2.01 0 100-4.02 2.01 2.01 0 000 4.02z",
  fill: "#74CADC"
})));

var EmptyStateWrapper = styled(Box)({
  width: "100%",
  padding: 0,
  justifyContent: "center"
});
var EmptyStateIconWrapper = styled(Icon)({
  width: 144,
  height: 144
});
var EmptyStateText = styled(Text)(function (props) {
  return {
    textAlign: "center",
    marginTop: 28,
    color: props.theme.colors.grey.dark
  };
});
var InfoBoxWrapper = styled(Box)(function (props) {
  return {
    padding: "16px 14px",
    marginTop: 32,
    width: 340,
    boxSizing: "border-box",
    backgroundColor: props.theme.colors.grey.soft,
    borderRadius: props.theme.radii.lg
  };
});
var StyledIcon = styled(Icon)({
  width: 24,
  height: 24,
  margin: "12px 8px 0px 0px"
});
var StyledLink = styled("a")(function (props) {
  return {
    fontSize: props.theme.fontSizes[3],
    fontWeight: props.theme.fontWeights.semiBold,
    color: props.theme.colors.blue.haptik
  };
});
function EmptyState(_ref) {
  var onAddButtonClick = _ref.onAddButtonClick,
    isSelectMode = _ref.isSelectMode;
  return /*#__PURE__*/React.createElement(EmptyStateWrapper, {
    "data-testid": "global-constants-empty-state"
  }, /*#__PURE__*/React.createElement(Box, {
    padding: "0px",
    width: "249px",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "72px"
  }, /*#__PURE__*/React.createElement(EmptyStateIconWrapper, {
    src: EmptyStateIcon
  }), /*#__PURE__*/React.createElement(EmptyStateText, {
    variant: "body.lg",
    style: {
      width: "220px"
    }
  }, "No Bot Variables added on your bot"), !isSelectMode ? /*#__PURE__*/React.createElement(Box, {
    padding: "0px",
    marginTop: "28px"
  }, /*#__PURE__*/React.createElement(AddButton, {
    onClick: onAddButtonClick
  })) : /*#__PURE__*/React.createElement(InfoBoxWrapper, null, /*#__PURE__*/React.createElement(StyledIcon, {
    src: "infoV2"
  }), /*#__PURE__*/React.createElement(Text, {
    variant: "body.lg",
    style: {
      width: "280px"
    }
  }, "To add Bot Variables on the bot, please follow the steps given in", " ", /*#__PURE__*/React.createElement(StyledLink, {
    href: "https://docs.haptik.ai/what-are-bot-variables-how-to-use-bot-variables",
    target: "_blank"
  }, "documentation")))));
}
EmptyState.propTypes = {
  /** When user clicks on Add a Bot Variable Button */
  onAddButtonClick: PropTypes.func,
  /** To show Add Button or Info Bar */
  isSelectMode: PropTypes.bool
};
EmptyState.defaultProps = {
  onAddButtonClick: function onAddButtonClick() {},
  isSelectMode: false
};
EmptyState.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EmptyState",
  "props": {
    "onAddButtonClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "When user clicks on Add a Bot Variable Button"
    },
    "isSelectMode": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "To show Add Button or Info Bar"
    }
  }
};

var EditIconV2 = function EditIconV2(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2889 8.68889L15.3111 9.71111L5.24444 19.7778H4.22222V18.7556L14.2889 8.68889ZM18.2889 2C18.0111 2 17.7222 2.11111 17.5111 2.32222L15.4778 4.35556L19.6444 8.52222L21.6778 6.48889C22.1111 6.05556 22.1111 5.35556 21.6778 4.92222L19.0778 2.32222C18.8556 2.1 18.5778 2 18.2889 2ZM14.2889 5.54444L2 17.8333V22H6.16667L18.4556 9.71111L14.2889 5.54444Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep)
  })));
};
EditIconV2.propTypes = {
  iconColor: PropTypes.string
};
EditIconV2.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EditIconV2",
  "props": {
    "iconColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
var EditIconV2$1 = withTheme(EditIconV2);

var BinIcon = function BinIcon(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8289 7.46338V20.6579C18.8289 21.3953 18.2281 22 17.4955 22H6.57284C5.84026 22 5.2395 21.3953 5.2395 20.6579V7.46338",
    stroke: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep),
    strokeWidth: "1.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 5.31679H15.962H8.08365H2",
    stroke: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep),
    strokeWidth: "1.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03297 5.26609V2.75018C8.03297 2.33682 8.44361 2 8.85426 2H15.2446C15.6553 2 15.9417 2.33937 15.9417 2.75018V5.26609",
    stroke: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep),
    strokeWidth: "1.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85536 7.46338V18.7237",
    stroke: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep),
    strokeWidth: "1.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3143 7.46338V18.7237",
    stroke: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep),
    strokeWidth: "1.8"
  })));
};
BinIcon.propTypes = {
  iconColor: PropTypes.string
};
BinIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BinIcon",
  "props": {
    "iconColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
var BinIcon$1 = withTheme(BinIcon);

var ListItemWrapper = styled(Box)(function (props) {
  return _objectSpread2$1({
    padding: 0,
    width: "100%",
    borderBottom: "1px solid ".concat(props.theme.colors.grey.haptik)
  }, props.isSelectMode ? {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: props.theme.colors.blue.pastel
    }
  } : {});
});
var ActionIconsWrapper = styled(Box)({
  padding: 0,
  gridGap: 16,
  marginLeft: 16,
  alignItems: "center"
});
var KeyTextWrapper = styled(Text)({
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
});
var ValueTextWrapper = styled(Text)({
  display: "-webkit-box",
  "-webkit-line-clamp": "2",
  "-webkit-box-orient": "vertical",
  overflow: "hidden",
  wordBreak: "break-all"
});
function GlobalConstantsListItem(_ref) {
  var _data$values;
  var data = _ref.data,
    isSelectMode = _ref.isSelectMode,
    onEdit = _ref.onEdit,
    onDelete = _ref.onDelete,
    onSelect = _ref.onSelect;
  return /*#__PURE__*/React.createElement(Animate, {
    entry: "fade-down"
  }, /*#__PURE__*/React.createElement(ListItemWrapper, {
    isSelectMode: isSelectMode,
    onClick: isSelectMode ? function () {
      return onSelect(data.key_name);
    } : null
  }, /*#__PURE__*/React.createElement(Box, {
    padding: "0px",
    margin: "8px 16px",
    width: "100%",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Box, {
    padding: "0px",
    flexDirection: "column",
    width: isSelectMode ? "350px" : "290px"
  }, /*#__PURE__*/React.createElement(KeyTextWrapper, {
    variant: "body.lg",
    color: "grey.deep"
  }, "~", data.key_name), /*#__PURE__*/React.createElement(ValueTextWrapper, {
    variant: "body.md",
    color: "grey.dark"
  }, (_data$values = data.values) === null || _data$values === void 0 || (_data$values = _data$values.en) === null || _data$values === void 0 ? void 0 : _data$values.en)), !isSelectMode && /*#__PURE__*/React.createElement(ActionIconsWrapper, {
    "data-testid": "globalconstants-actions"
  }, /*#__PURE__*/React.createElement(EditIconV2$1, {
    size: "small",
    iconColor: "grey.dark",
    onClick: function onClick() {
      return onEdit(data);
    },
    style: {
      cursor: "pointer"
    }
  }), /*#__PURE__*/React.createElement(BinIcon$1, {
    size: "small",
    iconColor: "grey.dark",
    onClick: function onClick() {
      return onDelete(data);
    },
    style: {
      cursor: "pointer"
    }
  })))));
}
GlobalConstantsListItem.propTypes = {
  /** Constant Data - id, key, value */
  data: PropTypes.object,
  /** Mode to show - Select or Add/Edit Global Constants */
  isSelectMode: PropTypes.bool,
  /** When user clicks on Edit Icon of Constant */
  onEdit: PropTypes.func,
  /** When user clicks on Delete Icon of Constant */
  onDelete: PropTypes.func,
  /** When user selects a constant in select mode */
  onSelect: PropTypes.func
};
GlobalConstantsListItem.defaultProps = {
  data: {},
  isSelectMode: false,
  onEdit: function onEdit() {},
  onDelete: function onDelete() {},
  onSelect: function onSelect() {}
};

var ListWrapper = styled(Box)(function (props) {
  return {
    padding: 0,
    borderTop: "1px solid ".concat(props.theme.colors.grey.haptik),
    flexDirection: "column",
    overflowY: "auto"
  };
});
function GlobalConstantsList(_ref) {
  var data = _ref.data,
    isSelectMode = _ref.isSelectMode,
    onEdit = _ref.onEdit,
    onDelete = _ref.onDelete,
    onSelect = _ref.onSelect;
  return /*#__PURE__*/React.createElement(ListWrapper, {
    "data-testid": "globalconstants-list"
  }, data.map(function (constant) {
    return /*#__PURE__*/React.createElement(GlobalConstantsListItem, {
      key: constant.key_name,
      data: constant,
      isSelectMode: isSelectMode,
      onEdit: onEdit,
      onDelete: onDelete,
      onSelect: onSelect
    });
  }));
}
GlobalConstantsList.propTypes = {
  /** Global Constants List */
  data: PropTypes.arrayOf(object),
  /** Mode to show - Select or Add/Edit Global Constants */
  isSelectMode: PropTypes.bool,
  /** When user clicks on Edit Icon of Constant */
  onEdit: PropTypes.func,
  /** When user clicks on Delete Icon of Constant */
  onDelete: PropTypes.func,
  /** When user selects a constant in select mode */
  onSelect: PropTypes.func
};
GlobalConstantsList.defaultProps = {
  data: [],
  isSelectMode: false,
  onEdit: function onEdit() {},
  onDelete: function onDelete() {},
  onSelect: function onSelect() {}
};
GlobalConstantsList.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "GlobalConstantsList",
  "props": {
    "data": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "object"
        }
      },
      "required": false,
      "description": "Global Constants List"
    },
    "isSelectMode": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Mode to show - Select or Add/Edit Global Constants"
    },
    "onEdit": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "When user clicks on Edit Icon of Constant"
    },
    "onDelete": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "When user clicks on Delete Icon of Constant"
    },
    "onSelect": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "When user selects a constant in select mode"
    }
  }
};

/**
 * Use to fetch the global constants data
 * @param apiUrl Base URL for the API Call
 */
var GlobalConstantsAPI = /*#__PURE__*/_createClass(function GlobalConstantsAPI() {
  var _this = this;
  _classCallCheck(this, GlobalConstantsAPI);
  // Fetches the data
  _defineProperty$1(this, "fetchData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _this.isLoading = true;
          _context.next = 3;
          return APIRequest(_this.apiUrl, "GET").then(function (_ref2) {
            var success = _ref2.success,
              response = _ref2.response;
            if (success) {
              if (response.body) {
                _this.data = response.body;
              }
            }
            _this.isLoading = false;
          })["catch"](function (error) {
            _this.data = [];
            _this.isLoading = false;
            Bole.error(error);
          });
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  // Returns the Global Constants Data
  _defineProperty$1(this, "getConstantsData", function () {
    return _this.data;
  });
  // Returns the API URL
  _defineProperty$1(this, "getApiUrl", function () {
    return _this.apiUrl;
  });
  // Set the API URL
  _defineProperty$1(this, "setApiUrl", /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(apiUrl) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this.apiUrl = apiUrl;
            // Update the data using new API URL
            _context2.next = 3;
            return _this.fetchData();
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }());
  _defineProperty$1(this, "getIsLoading", function () {
    return _this.isLoading;
  });
  this.data = [];
  this.apiUrl = "";
  this.isLoading = false;
});
var API = {
  GlobalConstantsAPI: GlobalConstantsAPI
};

var WarningBoxWrapper = styled(Box)(function (props) {
  return {
    backgroundColor: props.theme.colors.yellow.pastel,
    borderRadius: props.theme.radii.sm,
    padding: "12px 18px",
    marginRight: 16,
    marginTop: 6,
    alignItems: "center"
  };
});
var WarningText = styled(Text)(function (props) {
  return {
    color: props.theme.colors.yellow.dark,
    marginLeft: 10
  };
});
var StyledSearch = styled(Search)(function (props) {
  return _objectSpread2$1({
    height: "34px"
  }, props.isWarning ? {
    borderColor: "".concat(props.theme.colors.red.haptik, " !important")
  } // !important is used to override the onFocus border colour.
  : {});
});
var defaultBoxStyles = {
  flexDirection: "column",
  padding: "0px"
};

// GlobalConstantsAPI is a class to get and fetch the data
var GlobalConstantsData = new API.GlobalConstantsAPI();

// Number of Constants Allowed to add
var CONSTANTS_LIMIT = 50;
var GlobalConstants = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var apiUrl = props.apiUrl,
    onAddButtonClick = props.onAddButtonClick,
    isSelectMode = props.isSelectMode,
    onEdit = props.onEdit,
    onDelete = props.onDelete,
    onSelect = props.onSelect;
  var _useState = useState(GlobalConstantsData.getConstantsData()),
    _useState2 = _slicedToArray$1(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1]; // Stores the actual data
  var _useState3 = useState(cloneDeep_1(data)),
    _useState4 = _slicedToArray$1(_useState3, 2),
    filteredData = _useState4[0],
    setFilteredData = _useState4[1]; // Stores Constants Data that need to be displayed
  var _useState5 = useState(""),
    _useState6 = _slicedToArray$1(_useState5, 2),
    searchTerm = _useState6[0],
    setSearchTerm = _useState6[1]; // Stores the searched string
  var _useState7 = useState(false),
    _useState8 = _slicedToArray$1(_useState7, 2),
    isConstantsLimitReached = _useState8[0],
    setIsConstantsLimitReached = _useState8[1]; // Stores whether the data has 50 constants
  var _useState9 = useState(false),
    _useState10 = _slicedToArray$1(_useState9, 2),
    isEmptySearchResults = _useState10[0],
    setIsEmptySearchResults = _useState10[1]; // When the searched constant is not found

  useEffect(function () {
    // Updates the filteredData and isConstantsLimitReached states when data prop is changed
    setFilteredData(data);
    setIsConstantsLimitReached((data === null || data === void 0 ? void 0 : data.length) === CONSTANTS_LIMIT);
  }, [data]);
  useEffect(function () {
    // If the apiUrl is changed then update it in GlobalConstantsData
    // While setting the url, GlobalConstantsData.setApiUrl function will automatically update the data using new URL.
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(GlobalConstantsData.getApiUrl() !== apiUrl)) {
              _context.next = 4;
              break;
            }
            _context.next = 3;
            return GlobalConstantsData.setApiUrl(apiUrl);
          case 3:
            setData(GlobalConstantsData.getConstantsData());
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }, [apiUrl]);

  // Expose the methods
  React.useImperativeHandle(ref, function () {
    return {
      // Refreshes Global Constants Data
      refreshData: function () {
        var _refreshData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return GlobalConstantsData.fetchData();
              case 2:
                setData(GlobalConstantsData.getConstantsData());
                setIsEmptySearchResults(false);
                setSearchTerm("");
              case 5:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function refreshData() {
          return _refreshData.apply(this, arguments);
        }
        return refreshData;
      }()
    };
  });

  // Handles the search
  var handleSearch = debounce(function (searchedValue) {
    var keyText = searchedValue;
    if (searchedValue && searchedValue.indexOf("~") === 0) {
      keyText = searchedValue.substring(1);
    }
    setSearchTerm(searchedValue);
    if (keyText) {
      var searchResult = data.filter(function (constant) {
        var _constant$key_name;
        return (_constant$key_name = constant.key_name) === null || _constant$key_name === void 0 ? void 0 : _constant$key_name.includes(keyText);
      });
      setFilteredData(searchResult);
      if (!searchResult.length && !isEmptySearchResults) {
        setIsEmptySearchResults(true);
      } else if (searchResult.length && isEmptySearchResults) {
        setIsEmptySearchResults(false);
      }
    } else {
      setFilteredData(cloneDeep_1(data));
      setIsEmptySearchResults(false);
    }
  }, 300);
  if (GlobalConstantsData.getIsLoading()) {
    return /*#__PURE__*/React.createElement(Box, {
      width: "100%",
      justifyContent: "center",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Loader, {
      themed: true
    }));
  }
  return /*#__PURE__*/React.createElement(Box, {
    padding: "0px",
    width: "100%",
    height: "100%"
  }, !data.length ? /*#__PURE__*/React.createElement(EmptyState, {
    onAddButtonClick: onAddButtonClick,
    isSelectMode: isSelectMode
  }) : /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    style: defaultBoxStyles
  }, /*#__PURE__*/React.createElement(Box, {
    margin: "16px",
    style: defaultBoxStyles,
    "data-testid": "globalconstants-header"
  }, /*#__PURE__*/React.createElement(StyledSearch, {
    onType: handleSearch,
    value: searchTerm,
    placeholder: "Search",
    isWarning: isEmptySearchResults
  }), isEmptySearchResults && /*#__PURE__*/React.createElement(Text, {
    variant: "body.sm",
    color: "red.haptik",
    style: {
      marginTop: 12
    },
    "data-testid": "search-error-state"
  }, "Constant does not exist.")), !isSelectMode && /*#__PURE__*/React.createElement(Box, {
    margin: "0px 0px 16px 16px",
    style: defaultBoxStyles
  }, /*#__PURE__*/React.createElement(AddButton, {
    onClick: onAddButtonClick,
    isDisabled: isConstantsLimitReached
  }), isConstantsLimitReached && /*#__PURE__*/React.createElement(WarningBoxWrapper, null, /*#__PURE__*/React.createElement(WarningIconV2$1, null), /*#__PURE__*/React.createElement(WarningText, {
    variant: "h5.semi-bold"
  }, "You can add upto 50 Global Constants only."))), /*#__PURE__*/React.createElement(GlobalConstantsList, {
    data: filteredData,
    isSelectMode: isSelectMode,
    onEdit: onEdit,
    onDelete: onDelete,
    onSelect: onSelect
  })));
});
GlobalConstants.propTypes = {
  /** Global Constants API  */
  apiUrl: PropTypes.string,
  /** When user clicks on Add a Global Constant/Bot Variable Button */
  onAddButtonClick: PropTypes.func,
  /** Mode to show - Select or Add/Edit Global Constants */
  isSelectMode: PropTypes.bool,
  /** When user clicks on Edit Icon of Constant */
  onEdit: PropTypes.func,
  /** When user clicks on Delete Icon of Constant */
  onDelete: PropTypes.func,
  /** When user selects a constant in select mode */
  onSelect: PropTypes.func
};
GlobalConstants.defaultProps = {
  apiUrl: "",
  onAddButtonClick: function onAddButtonClick() {},
  isSelectMode: false,
  onEdit: function onEdit() {},
  onDelete: function onDelete() {},
  onSelect: function onSelect() {}
};

export { GlobalConstants as G, Search as S };
